import DOMPurify from 'isomorphic-dompurify'

const useSanitize = markDown => {
    const clean = DOMPurify.sanitize(markDown)
    return clean
}

export default useSanitize